import { render, staticRenderFns } from "./ManageAssetLinkTypes.vue?vue&type=template&id=4b437e52&scoped=true"
import script from "./ManageAssetLinkTypes.vue?vue&type=script&lang=js"
export * from "./ManageAssetLinkTypes.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ManageAssetLinkTypes.vue?vue&type=style&index=1&id=4b437e52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b437e52",
  null
  
)

export default component.exports